module.exports = __webpack_public_path__ + "img/calendar.60142f1e.svg";